export const BRAND_NAME = "My Clean Connect";
export const LOGO_ICON = "/mcc-mark.png";
export const LOGO_FULL = "/mcc-logo.png";
export const BANNER = "/mcc-banner.png";
